<template>
	<label class="app-switch" :class="{ 'app-switch__disabled': disabled }">
		<input v-model="model" :disabled="disabled" type="checkbox" :checked="checked" />

		<span class="app-switch__switch"></span>

		<slot name="label" :value="label">
			<span v-if="label" class="app-switch__label">{{ label }}</span>
		</slot>
	</label>
</template>

<script setup lang="ts">
	interface IProps {
		label?: string;
		disabled?: boolean;
		checked?: boolean;
	}

	const model = defineModel<boolean>({ required: true, default: false });

	withDefaults(defineProps<IProps>(), {
		label: '',
		disabled: false,
		checked: false,
	});
</script>

<style scoped lang="scss">
	.app-switch {
		cursor: pointer;
		display: flex;
		align-items: center;
		gap: 12px;

		input {
			position: absolute;
			width: 1px;
			height: 1px;
			padding: 0;
			margin: -1px;
			overflow: hidden;
			clip: rect(0, 0, 0, 0);
			white-space: nowrap;
			border-width: 0;
		}

		input:focus-visible ~ .app-switch__switch,
		&:hover .app-switch__switch {
			border-color: var(--color-grey-dark);
		}

		&__switch {
			display: flex;
			align-items: center;
			position: relative;
			height: 31px;
			width: 60px;
			box-shadow: var(--box-shadow);
			border-radius: 16px;
			border: 1px solid var(--color-white);
			background-color: var(--color-white);
			flex-shrink: 0;
			transition: border-color 0.2s ease-in-out;

			&::before {
				content: '';
				position: absolute;
				height: 27px;
				width: 27px;
				border-radius: 50%;
				left: 2px;
				background-color: var(--color-grey-dark);
				transition: transform 0.3s ease-in-out;
			}
		}

		&__disabled {
			cursor: default;
		}
	}

	// input:checked + .app-switch__switch {
	// 	background-color: var(--color-white);
	// }
	input:checked + .app-switch__switch::before {
		transform: translateX(28px);
		background-color: var(--color-primary);
	}
	input:disabled + .app-switch__switch + .app-switch__label {
		cursor: default;
		opacity: 0.8;
	}
	input:disabled + .app-switch__switch::before {
		cursor: default;
		opacity: 0.8;
	}
</style>
